/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Deload_TitleInputs */

const en_us2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deload workout`)
};

const pt_br2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de deload`)
};

const es_419_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento de descarga`)
};

const pt_pt2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de deload`)
};

const fr_fr2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance de décharge`)
};

const de_de2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deload-Training`)
};

const it_it2_plan_deload_title = /** @type {(inputs: Plan_Deload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento di scarico`)
};

/**
* | output |
* | --- |
* | "Deload workout" |
*
* @param {Plan_Deload_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_deload_title = /** @type {((inputs?: Plan_Deload_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Deload_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_deload_title(inputs)
	if (locale === "es-419") return es_419_plan_deload_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_deload_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_deload_title(inputs)
	if (locale === "de-DE") return de_de2_plan_deload_title(inputs)
	if (locale === "it-IT") return it_it2_plan_deload_title(inputs)
	return en_us2_plan_deload_title(inputs)
});
export { plan_deload_title as "plan.deload.title" }